module.exports = __webpack_public_path__ + "img/testimonial1.67163699.png";